<!-- Barra de controles (no se imprime) -->
<div class="controles-container no-print">
  <div class="row">
    <div class="col-md-12">
      <label>AÑO DESDE:</label>&nbsp;
      <input type="number" [(ngModel)]="anio" (change)="onAnioChange()" style="width: 80px;" min="2000" max="2100">
      &nbsp;&nbsp;
      <label>AÑO HASTA:</label>&nbsp;
      <input type="number" [(ngModel)]="anioHasta" style="width: 80px;" min="2000" max="2100">
      &nbsp;&nbsp;
      <label>DESDE:</label>&nbsp;
      <select [(ngModel)]="desdeMonth" style="width: 110px;">
        <option *ngFor="let mes of meses" [ngValue]="mes.value">{{ mes.label }}</option>
      </select>
      &nbsp;&nbsp;
      <label>HASTA:</label>&nbsp;
      <select [(ngModel)]="hastaMonth" style="width: 110px;">
        <option *ngFor="let mes of meses" [ngValue]="mes.value">{{ mes.label }}</option>
      </select>
      &nbsp;&nbsp;
      <label>CUIT:</label>&nbsp;
      <app-cuit-input [(ngModel)]="cuit" inputStyle="width: 140px;"></app-cuit-input>
      &nbsp;
      <button type="button" class="btn btn-outline-success btn-sm" (click)="abrirModalCrearEmpresa()" title="Crear empresa nueva si no existe">
        <i class="fa fa-plus"></i> Crear Empresa
      </button>
      &nbsp;&nbsp;
      <label>FECHA LIQ:</label>&nbsp;
      <input type="text" [(ngModel)]="fechaLiquidacion" placeholder="DD/MM/YYYY" maxlength="10" style="width: 100px;" (change)="recalcularTodosLosPeriodos()">
      &nbsp;&nbsp;
      <label>TASA INT.:</label>&nbsp;
      <input type="number" [(ngModel)]="tasaInteres" step="0.001" min="0" max="1" style="width: 80px;" (change)="calcularValoresDerivados(); calcularTotales();">
      &nbsp;&nbsp;
      <button type="button" class="btn btn-info" (click)="abrirModalConfiguracion()">
        <i class="fa fa-cog"></i> CONFIGURAR %
      </button>
      &nbsp;
      <button type="button" class="btn btn-primary" (click)="buscarEmpresa()" [disabled]="loading || !cuit || !anio">
        <span *ngIf="!loading">BUSCAR DATOS</span>
        <span *ngIf="loading"><i class="fa fa-spinner fa-spin"></i> CARGANDO...</span>
      </button>
      &nbsp;
      <button type="button" class="btn btn-success" (click)="imprimirPopup()" [disabled]="!empresa">
        <i class="fa fa-print"></i> IMPRIMIR
      </button>
      &nbsp;
      <button type="button" class="btn btn-warning" (click)="guardarLiquidacion()" [disabled]="!empresa || guardando">
        <span *ngIf="!guardando"><i class="fa fa-save"></i> GUARDAR</span>
        <span *ngIf="guardando"><i class="fa fa-spinner fa-spin"></i> GUARDANDO...</span>
      </button>
      &nbsp;
      <button *ngIf="liquidacionId" type="button" class="btn btn-secondary" (click)="nuevaLiquidacion()">
        <i class="fa fa-plus"></i> NUEVA
      </button>
      &nbsp;
      <button type="button" class="btn btn-outline-info" routerLink="/liquidaciones-guardadas">
        <i class="fa fa-archive"></i> VER GUARDADAS
      </button>
      <span *ngIf="liquidacionId" class="badge badge-warning ml-2" style="font-size: 14px; vertical-align: middle;">
        Editando #{{liquidacionId}}
      </span>
    </div>
  </div>

  <!-- Aviso empresa no registrada -->
  <div class="row mt-2" *ngIf="empresaNoRegistrada">
    <div class="col-md-12">
      <div class="alert alert-warning" style="margin-bottom: 0;">
        <strong><i class="fa fa-exclamation-triangle"></i> Empresa no registrada en el sistema</strong><br>
        El CUIT <strong>{{cuit}}</strong> no está dado de alta en el módulo de Empresas.
        <span style="margin-top: 4px; display: inline-block;">
          <strong>Opción A:</strong> Escribí la razón social directamente en el campo <strong>EMPRESA</strong> del formulario de abajo — los botones GUARDAR e IMPRIMIR se habilitarán automáticamente.<br>
          <strong>Opción B:</strong> Registrá la empresa en
          <a href="/empresas" target="_blank" style="font-weight: bold;">/empresas</a>
          y volvé a hacer clic en <strong>BUSCAR DATOS</strong>.
        </span>
      </div>
    </div>
  </div>

  <!-- Información de porcentajes activos -->
  <div class="row mt-2" *ngIf="aporteSeleccionado || contribucionSeleccionada">
    <div class="col-md-12">
      <small class="text-muted">
        <strong>Porcentajes activos:</strong>
        <span *ngIf="aporteSeleccionado">
          Aporte: <span class="badge badge-primary">{{ formatearPorcentaje(aporteSeleccionado.porcentaje) }}</span> ({{ aporteSeleccionado.titulo }})
        </span>
        &nbsp;&nbsp;
        <span *ngIf="contribucionSeleccionada">
          Contribución: <span class="badge badge-success">{{ formatearPorcentaje(contribucionSeleccionada.porcentaje) }}</span> ({{ contribucionSeleccionada.titulo }})
        </span>
      </small>
    </div>
  </div>

  <!-- Navegación multi-año (solo visible cuando hay múltiples años) -->
  <div class="row mt-3" *ngIf="liquidacionesAnios.length > 1">
    <div class="col-md-12">
      <div class="navegacion-anios">
        <button type="button" class="btn btn-secondary" (click)="navegarAnioAnterior()" [disabled]="anioActualIndex === 0">
          <i class="fa fa-chevron-left"></i> Anterior
        </button>
        <span class="anio-actual-indicador">
          <strong>Año {{ liquidacionesAnios[anioActualIndex]?.anio }}</strong>
          <small>({{ anioActualIndex + 1 }} de {{ liquidacionesAnios.length }})</small>
        </span>
        <button type="button" class="btn btn-secondary" (click)="navegarAnioSiguiente()" [disabled]="anioActualIndex === liquidacionesAnios.length - 1">
          Siguiente <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ACTA DE INTIMACION DE PAGO -->
<!-- MODO MULTI-AÑO: Iterar sobre cada año (mostrar solo el actual en pantalla) -->
<ng-container *ngIf="liquidacionesAnios.length > 0">
  <div *ngFor="let liqAnio of liquidacionesAnios; let i = index; let isLast = last"
       [class.anio-oculto-pantalla]="i !== anioActualIndex"
       [class.pagina-anio-siguiente]="i > 0"
       class="acta-container">
    <!-- Primera página - Acta -->
    <div id="pagina-primera-acta-{{liqAnio.anio}}" class="pagina-primera-acta">
    <!-- Titulo principal -->
    <div class="acta-titulo">
      <h4>ACTA DE INTIMACION DE PAGO:</h4>
    </div>

  <!-- Encabezado institucional -->
  <table class="tabla-encabezado">
    <tr>
      <td rowspan="3" class="logo-cell">
        <!-- Logo OS-RGA -->
        <img src="assets/img/osrga.jpeg" alt="OS.R.GA" class="logo-osrga">
      </td>
      <td class="subtitulo-cell">
        ANALISIS DE DEUDA<br>
        LEY 23.660
      </td>
      <td class="periodo-verificar">
        PERIODO A VERIFICAR DE OBRA SOCIAL: 10 AÑOS
      </td>
    </tr>
    <tr>
      <td class="campo-editable">
        <strong>AÑO</strong><br>
        <span class="valor-campo">{{liqAnio.anio}}</span>
      </td>
      <td class="campo-editable">
        <strong>CUIT N°</strong>
        <span class="valor-campo">{{cuit || '-'}}</span>
        &nbsp;&nbsp;&nbsp;
        <strong>FECHA LIQUIDACION:</strong>
        <span class="valor-campo">{{fechaLiquidacion}}</span>
      </td>
    </tr>
    <tr>
      <td class="campo-editable">
        <strong>EMPRESA</strong><br>
        <input type="text" [(ngModel)]="empresa" class="input-editable empresa-input" placeholder="Nombre de empresa" autocomplete="off">
      </td>
      <td class="campo-editable">
        <strong>DOMICILIO:</strong><br>
        <input type="text" [(ngModel)]="domicilio" class="input-editable domicilio-input" placeholder="Dirección">
      </td>
    </tr>
  </table>

  <!-- Tabla de detalle mensual -->
  <table class="tabla-liquidacion">
    <thead>
      <tr class="header-row">
        <th rowspan="2">
          Periodo
          <i class="fas fa-info-circle tooltip-icon" title="Mes o período de liquidación (ENE-DIC, 1°SAC, 2°SAC)"></i>
        </th>
        <th rowspan="2">
          Cantidad<br>Personal
          <i class="fas fa-info-circle tooltip-icon" title="Número de empleados registrados en ese período según declaraciones juradas"></i>
        </th>
        <th rowspan="2">
          REMUNERACION TOTAL
          <i class="fas fa-info-circle tooltip-icon" title="Suma total de salarios pagados a todos los empleados en el período"></i>
        </th>
        <th rowspan="2">
          Importe a Pagar
          <i class="fas fa-info-circle tooltip-icon" title="Monto que la empresa debe depositar. Cálculo: Remuneración × (Aporte% + Contribución%)"></i>
        </th>
        <th rowspan="2">
          Aporte
          <i class="fas fa-info-circle tooltip-icon" title="2.55% de la remuneración total (aportes del trabajador descontados del salario)"></i>
        </th>
        <th rowspan="2">
          Contribución
          <i class="fas fa-info-circle tooltip-icon" title="5.1% de la remuneración total (contribución patronal a cargo del empleador)"></i>
        </th>
        <th colspan="2">
          Detalles de importes<br>depositados
          <i class="fas fa-info-circle tooltip-icon" title="Montos efectivamente depositados por la empresa en transferencias bancarias"></i>
        </th>
        <th rowspan="2">
          Fecha de<br>Vencimiento
          <i class="fas fa-info-circle tooltip-icon" title="Fecha límite de pago según terminación del CUIT (día 9, 10 u 11 del mes siguiente)"></i>
        </th>
        <th rowspan="2">
          Dias de Mora
          <i class="fas fa-info-circle tooltip-icon" title="Días transcurridos desde la fecha de vencimiento hasta la fecha de liquidación"></i>
        </th>
        <th rowspan="2">
          DIFERENCIA<br>PAGO<br>PARCIAL
          <i class="fas fa-info-circle tooltip-icon" title="Diferencia entre lo depositado y lo que se debía pagar. Negativo = pagó de menos"></i>
        </th>
        <th rowspan="2">
          INTERESES POR<br>PAGO FUERA DE<br>TERMINO
          <i class="fas fa-info-circle tooltip-icon" title="Intereses calculados sobre pagos realizados fuera de término"></i>
        </th>
        <th rowspan="2">
          APORTES Y<br>CONTR. NO<br>DEPOSITADAS
          <i class="fas fa-info-circle tooltip-icon" title="Montos no depositados cuando la diferencia de pago es negativa"></i>
        </th>
        <th rowspan="2">
          SALDO DEUDOR
          <i class="fas fa-info-circle tooltip-icon" title="Saldo acumulado de deuda del período (aportes no depositados)"></i>
        </th>
        <th rowspan="2">
          ACTUALIZACION<br>DE INTERESES
          <i class="fas fa-info-circle tooltip-icon" title="Actualización diaria de intereses. Cálculo: Saldo Deudor × Tasa × Días de Mora"></i>
        </th>
        <th rowspan="2">
          TOTAL ADEUDADO<br>DEL PERIODO
          <i class="fas fa-info-circle tooltip-icon" title="Suma total de la deuda del período (Saldo Deudor + Actualización de Intereses)"></i>
        </th>
      </tr>
      <tr class="header-row-sub">
        <th>
          IMPORTE
          <i class="fas fa-info-circle tooltip-icon" title="Monto del depósito bancario realizado"></i>
        </th>
        <th>
          FECHA
          <i class="fas fa-info-circle tooltip-icon" title="Fecha en que se realizó el depósito bancario"></i>
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let p of liqAnio.periodos">
      <tr *ngIf="p.totalAdeudadoPeriodo > 0" [class.sac-row]="p.periodo.includes('SAC')">
        <td class="periodo-col">{{p.periodo}}</td>
        <td class="numero-col">
          <input type="number" [(ngModel)]="p.cantidadPersonal" class="input-tabla input-numero" (change)="recalcularPeriodo(p)">
        </td>
        <td class="moneda-col">
          <input type="number" [(ngModel)]="p.remuneracionTotal" class="input-tabla input-moneda" (change)="recalcularPeriodo(p)">
        </td>
        <td class="moneda-col">{{p.importeAPagar ? formatCurrency(p.importeAPagar) : '0,00'}}</td>
        <td class="moneda-col">{{p.aporte ? formatCurrency(p.aporte) : '0,00'}}</td>
        <td class="moneda-col">{{p.contribucion ? formatCurrency(p.contribucion) : '0,00'}}</td>
        <td class="moneda-col">
          <input type="number" [(ngModel)]="p.detalleImporte" class="input-tabla input-moneda" (change)="recalcularPeriodo(p)">
        </td>
        <td class="fecha-col">
          <input type="text" [(ngModel)]="p.detalleFecha" class="input-tabla input-fecha" placeholder="DD/MM/YYYY" maxlength="10" (change)="recalcularPeriodo(p)">
        </td>
        <td class="fecha-col fecha-vencimiento" [class.vencido]="p.diasMora > 0">{{p.fechaVencimiento}}</td>
        <td class="numero-col">{{p.diasMora || ''}}</td>
        <td class="moneda-col">{{p.diferenciaPagoParcial ? formatCurrency(p.diferenciaPagoParcial) : '0,00'}}</td>
        <td class="moneda-col">{{p.interesesPagoFueraTermino ? formatCurrency(p.interesesPagoFueraTermino) : '0,00'}}</td>
        <td class="moneda-col">{{p.aportesContrNoDepositadas ? formatCurrency(p.aportesContrNoDepositadas) : '0,00'}}</td>
        <td class="moneda-col">{{p.saldoDeudor ? formatCurrency(p.saldoDeudor) : '0,00'}}</td>
        <td class="moneda-col">{{p.actualizacionIntereses ? formatCurrency(p.actualizacionIntereses) : '0,00'}}</td>
        <td class="moneda-col total-col" [class.con-deuda]="p.totalAdeudadoPeriodo > 0">
          <strong>{{p.totalAdeudadoPeriodo ? formatCurrency(p.totalAdeudadoPeriodo) : '0,00'}}</strong>
        </td>
      </tr>
      </ng-container>
    </tbody>
    <tfoot>
      <tr class="total-row">
        <td class="periodo-col"><strong>TOTAL</strong></td>
        <td class="numero-col"></td>
        <td class="moneda-col"><strong>{{formatCurrency(liqAnio.totalRemuneracion)}}</strong></td>
        <td class="moneda-col"><strong>{{formatCurrency(liqAnio.totalImporteAPagar)}}</strong></td>
        <td class="moneda-col"></td>
        <td class="moneda-col"></td>
        <td class="moneda-col"></td>
        <td class="fecha-col"></td>
        <td class="fecha-col"></td>
        <td class="numero-col"></td>
        <td class="moneda-col"><strong>{{formatCurrency(liqAnio.totalDiferenciaPago)}}</strong></td>
        <td class="moneda-col"><strong>{{formatCurrency(liqAnio.totalIntereses)}}</strong></td>
        <td class="moneda-col"><strong>{{formatCurrency(liqAnio.totalAportesNoDepo)}}</strong></td>
        <td class="moneda-col"><strong>{{formatCurrency(liqAnio.totalSaldoDeudor)}}</strong></td>
        <td class="moneda-col"><strong>{{formatCurrency(liqAnio.totalActualizacion)}}</strong></td>
        <td class="moneda-col total-col con-deuda"><strong>{{formatCurrency(liqAnio.totalAdeudado)}}</strong></td>
        <td class="no-print"></td>
      </tr>
    </tfoot>
  </table>

  <!-- Observaciones -->
  <div class="observaciones-container">
    <div class="observaciones-label">OBSERVACIONES</div>
    <textarea [(ngModel)]="observaciones" class="observaciones-textarea" rows="3"></textarea>
  </div>

  <!-- Firma -->
  <div class="firma-container">
    <div class="firma-linea"></div>
    <div class="firma-texto">FIRMA Y ACLARACION DEL INSPECTOR</div>
  </div>
  </div><!-- Fin pagina-primera-acta -->

  </div>

  <!-- Resumen unico de deuda para todos los años (fuera del ngFor) -->
  <div class="page-break"></div>
  <div class="resumen-deuda-container">
    <!-- Encabezado -->
    <div class="resumen-header">
      <div class="resumen-logo">
        <img src="assets/img/osrga.jpeg" alt="OS.R.GA" class="logo-resumen">
      </div>
      <div class="resumen-titulo">
        <strong>OBRA SOCIAL DE RECIBIDORES DE GRANOS Y ANEXOS</strong><br>
        <strong>RNOS N° 118804</strong><br>
        <small>Av. Belgrano 510 - 5° Piso - Buenos Aires C.P. 1092 - Tel/Fax: 011 - 4331-0865</small><br>
        <small><a href="http://www.osrga.org.ar">www.osrga.org.ar</a></small>
      </div>
    </div>

    <!-- Datos del documento -->
    <table class="resumen-datos">
      <tr>
        <td><strong>Fecha:</strong></td>
        <td class="resumen-valor"><input type="text" [(ngModel)]="fechaLiquidacion" class="input-resumen" (change)="recalcularTodosLosPeriodos()"></td>
        <td><strong>VENCIMIENTO - PAGO OBLIGACIÓN:</strong></td>
        <td class="resumen-valor"><input type="text" [(ngModel)]="vencimientoPagoObligacion" class="input-resumen" placeholder="DD/MM/YYYY"></td>
      </tr>
      <tr>
        <td><strong>Razón Social o Apellido y Nombres:</strong></td>
        <td class="resumen-valor"><input type="text" [(ngModel)]="empresa" class="input-resumen" autocomplete="off"></td>
        <td><strong>CUIT:</strong></td>
        <td class="resumen-valor"><input type="text" [(ngModel)]="cuit" class="input-resumen"></td>
      </tr>
      <tr>
        <td><strong>Domicilio:</strong></td>
        <td class="resumen-valor" colspan="3"><input type="text" [(ngModel)]="domicilio" class="input-resumen input-wide"></td>
      </tr>
    </table>

    <!-- Tabla de montos -->
    <table class="resumen-montos">
      <tr>
        <td class="resumen-concepto">DIFERENCIA PAGO PARCIAL</td>
        <td class="resumen-monto">$ {{formatCurrency(getGrandTotal('totalDiferenciaPago'))}}</td>
      </tr>
      <tr>
        <td class="resumen-concepto">INTERESES POR PAGO FUERA DE TERMINO</td>
        <td class="resumen-monto">$ {{formatCurrency(getGrandTotal('totalIntereses'))}}</td>
      </tr>
      <tr>
        <td class="resumen-concepto">APORTES Y CONTR. NO DEPOSITADAS</td>
        <td class="resumen-monto">$ {{formatCurrency(getGrandTotal('totalAportesNoDepo'))}}</td>
      </tr>
      <tr>
        <td class="resumen-concepto">SALDO DEUDOR</td>
        <td class="resumen-monto">$ {{formatCurrency(getGrandTotal('totalSaldoDeudor'))}}</td>
      </tr>
      <tr>
        <td class="resumen-concepto">ACTUALIZACION DE INTERESES</td>
        <td class="resumen-monto">$ {{formatCurrency(getGrandTotal('totalActualizacion'))}}</td>
      </tr>
      <tr class="resumen-total-row">
        <td class="resumen-concepto"><strong>TOTAL ADEUDADO DEL PERIODO</strong></td>
        <td class="resumen-monto"><strong>$ {{formatCurrency(getGrandTotal('totalAdeudado'))}}</strong></td>
      </tr>
    </table>

    <!-- Texto legal -->
    <div class="resumen-texto-legal" *ngIf="textoLegalActivo">
      <p>{{textoLegalP1Pre}}<input type="number" [(ngModel)]="diasPlazo" class="input-dias" value="5"> (<input type="text" [(ngModel)]="diasPlazoLetras" class="input-dias-letras" placeholder="cinco">){{textoLegalP1Post}}</p>
      <p>{{textoLegalP2Normal}}<strong>{{textoLegalP2Negrita}}</strong></p>
    </div>

    <!-- Datos representante -->
    <div class="resumen-representante">
      <p>En la persona del Sr. <input type="text" [(ngModel)]="representanteNombre" class="input-representante"> con domicilio legal en <input type="text" [(ngModel)]="representanteDomicilio" class="input-representante"></p>
      <p>quien exhibió D.N.I. N° <input type="text" [(ngModel)]="representanteDNI" class="input-dni"> en su carácter de <input type="text" [(ngModel)]="representanteCargo" class="input-cargo"> de la empresa inspeccionada, firmante del Acta que se actualiza, se notifica de la conformación definitiva de las deudas, formando, la presente, parte integrante del instrumento mencionado.</p>
    </div>

    <!-- Firmas finales -->
    <div class="resumen-firmas">
      <div class="resumen-firma-col">
        <div class="firma-linea"></div>
        <strong>Inspector</strong><br>
        <small>Firma y Sello</small>
      </div>
      <div class="resumen-firma-col">
        <div class="firma-linea"></div>
        <strong>Fecha de Notificación</strong>
      </div>
      <div class="resumen-firma-col">
        <div class="firma-linea"></div>
        <strong>Responsable</strong><br>
        <small>Firma y Sello</small>
      </div>
    </div>
  </div>
</ng-container>

<!-- MODO AÑO ÚNICO: Mostrar datos del año único (backward compatible) -->
<div *ngIf="liquidacionesAnios.length === 0" class="acta-container">
  <!-- Primera página - Acta -->
  <div id="pagina-primera-acta" class="pagina-primera-acta">
    <!-- Titulo principal -->
    <div class="acta-titulo">
      <h4>ACTA DE INTIMACION DE PAGO:</h4>
    </div>

  <!-- Encabezado institucional -->
  <table class="tabla-encabezado">
    <tr>
      <td rowspan="3" class="logo-cell">
        <!-- Logo OS-RGA -->
        <img src="assets/img/osrga.jpeg" alt="OS.R.GA" class="logo-osrga">
      </td>
      <td class="subtitulo-cell">
        ANALISIS DE DEUDA<br>
        LEY 23.660
      </td>
      <td class="periodo-verificar">
        PERIODO A VERIFICAR DE OBRA SOCIAL: 10 AÑOS
      </td>
    </tr>
    <tr>
      <td class="campo-editable">
        <strong>AÑO</strong><br>
        <span class="valor-campo">{{anio}}</span>
      </td>
      <td class="campo-editable">
        <strong>CUIT N°</strong>
        <span class="valor-campo">{{cuit || '-'}}</span>
        &nbsp;&nbsp;&nbsp;
        <strong>FECHA LIQUIDACION:</strong>
        <span class="valor-campo">{{fechaLiquidacion}}</span>
      </td>
    </tr>
    <tr>
      <td class="campo-editable">
        <strong>EMPRESA</strong><br>
        <input type="text" [(ngModel)]="empresa" class="input-editable empresa-input" placeholder="Nombre de empresa" autocomplete="off">
      </td>
      <td class="campo-editable">
        <strong>DOMICILIO:</strong><br>
        <input type="text" [(ngModel)]="domicilio" class="input-editable domicilio-input" placeholder="Dirección">
      </td>
    </tr>
  </table>

  <!-- Tabla de detalle mensual -->
  <table class="tabla-liquidacion">
    <thead>
      <tr class="header-row">
        <th rowspan="2">
          Periodo
          <i class="fas fa-info-circle tooltip-icon" title="Mes o período de liquidación (ENE-DIC, 1°SAC, 2°SAC)"></i>
        </th>
        <th rowspan="2">
          Cantidad<br>Personal
          <i class="fas fa-info-circle tooltip-icon" title="Número de empleados registrados en ese período según declaraciones juradas"></i>
        </th>
        <th rowspan="2">
          REMUNERACION TOTAL
          <i class="fas fa-info-circle tooltip-icon" title="Suma total de salarios pagados a todos los empleados en el período"></i>
        </th>
        <th rowspan="2">
          Importe a Pagar
          <i class="fas fa-info-circle tooltip-icon" title="Monto que la empresa debe depositar. Cálculo: Remuneración × (Aporte% + Contribución%)"></i>
        </th>
        <th rowspan="2">
          Aporte
          <i class="fas fa-info-circle tooltip-icon" title="2.55% de la remuneración total (aportes del trabajador descontados del salario)"></i>
        </th>
        <th rowspan="2">
          Contribución
          <i class="fas fa-info-circle tooltip-icon" title="5.1% de la remuneración total (contribución patronal a cargo del empleador)"></i>
        </th>
        <th colspan="2">
          Detalles de importes<br>depositados
          <i class="fas fa-info-circle tooltip-icon" title="Montos efectivamente depositados por la empresa en transferencias bancarias"></i>
        </th>
        <th rowspan="2">
          Fecha de<br>Vencimiento
          <i class="fas fa-info-circle tooltip-icon" title="Fecha límite de pago según terminación del CUIT (día 9, 10 u 11 del mes siguiente)"></i>
        </th>
        <th rowspan="2">
          Dias de Mora
          <i class="fas fa-info-circle tooltip-icon" title="Días transcurridos desde la fecha de vencimiento hasta la fecha de liquidación"></i>
        </th>
        <th rowspan="2">
          DIFERENCIA<br>PAGO<br>PARCIAL
          <i class="fas fa-info-circle tooltip-icon" title="Diferencia entre lo depositado y lo que se debía pagar. Negativo = pagó de menos"></i>
        </th>
        <th rowspan="2">
          INTERESES POR<br>PAGO FUERA DE<br>TERMINO
          <i class="fas fa-info-circle tooltip-icon" title="Intereses calculados sobre pagos realizados fuera de término"></i>
        </th>
        <th rowspan="2">
          APORTES Y<br>CONTR. NO<br>DEPOSITADAS
          <i class="fas fa-info-circle tooltip-icon" title="Montos no depositados cuando la diferencia de pago es negativa"></i>
        </th>
        <th rowspan="2">
          SALDO DEUDOR
          <i class="fas fa-info-circle tooltip-icon" title="Saldo acumulado de deuda del período (aportes no depositados)"></i>
        </th>
        <th rowspan="2">
          ACTUALIZACION<br>DE INTERESES
          <i class="fas fa-info-circle tooltip-icon" title="Actualización diaria de intereses. Cálculo: Saldo Deudor × Tasa × Días de Mora"></i>
        </th>
        <th rowspan="2">
          TOTAL ADEUDADO<br>DEL PERIODO
          <i class="fas fa-info-circle tooltip-icon" title="Suma total de la deuda del período (Saldo Deudor + Actualización de Intereses)"></i>
        </th>
      </tr>
      <tr class="header-row-sub">
        <th>
          IMPORTE
          <i class="fas fa-info-circle tooltip-icon" title="Monto del depósito bancario realizado"></i>
        </th>
        <th>
          FECHA
          <i class="fas fa-info-circle tooltip-icon" title="Fecha en que se realizó el depósito bancario"></i>
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let p of periodos">
      <tr *ngIf="p.totalAdeudadoPeriodo > 0" [class.sac-row]="p.periodo.includes('SAC')">
        <td class="periodo-col">{{p.periodo}}</td>
        <td class="numero-col">
          <input type="number" [(ngModel)]="p.cantidadPersonal" class="input-tabla input-numero" (change)="recalcularPeriodo(p)">
        </td>
        <td class="moneda-col">
          <input type="number" [(ngModel)]="p.remuneracionTotal" class="input-tabla input-moneda" (change)="recalcularPeriodo(p)">
        </td>
        <td class="moneda-col">{{p.importeAPagar ? formatCurrency(p.importeAPagar) : '0,00'}}</td>
        <td class="moneda-col">{{p.aporte ? formatCurrency(p.aporte) : '0,00'}}</td>
        <td class="moneda-col">{{p.contribucion ? formatCurrency(p.contribucion) : '0,00'}}</td>
        <td class="moneda-col">
          <input type="number" [(ngModel)]="p.detalleImporte" class="input-tabla input-moneda" (change)="recalcularPeriodo(p)">
        </td>
        <td class="fecha-col">
          <input type="text" [(ngModel)]="p.detalleFecha" class="input-tabla input-fecha" placeholder="DD/MM/YYYY" (change)="recalcularPeriodo(p)">
        </td>
        <td class="fecha-col">{{p.fechaVencimiento}}</td>
        <td class="numero-col">{{p.diasMora}}</td>
        <td class="moneda-col">{{p.diferenciaPagoParcial ? formatCurrency(p.diferenciaPagoParcial) : '0,00'}}</td>
        <td class="moneda-col">{{p.interesesPagoFueraTermino ? formatCurrency(p.interesesPagoFueraTermino) : '0,00'}}</td>
        <td class="moneda-col">{{p.aportesContrNoDepositadas ? formatCurrency(p.aportesContrNoDepositadas) : '0,00'}}</td>
        <td class="moneda-col">{{p.saldoDeudor ? formatCurrency(p.saldoDeudor) : '0,00'}}</td>
        <td class="moneda-col">{{p.actualizacionIntereses ? formatCurrency(p.actualizacionIntereses) : '0,00'}}</td>
        <td class="moneda-col">{{p.totalAdeudadoPeriodo ? formatCurrency(p.totalAdeudadoPeriodo) : '0,00'}}</td>
      </tr>
      </ng-container>
    </tbody>
    <tfoot>
      <tr class="total-row">
        <td class="periodo-col"><strong>TOTAL</strong></td>
        <td class="numero-col"></td>
        <td class="moneda-col"><strong>{{formatCurrency(totalRemuneracion)}}</strong></td>
        <td class="moneda-col"><strong>{{formatCurrency(totalImporteAPagar)}}</strong></td>
        <td class="moneda-col"></td>
        <td class="moneda-col"></td>
        <td class="moneda-col"></td>
        <td class="fecha-col"></td>
        <td class="fecha-col"></td>
        <td class="numero-col"></td>
        <td class="moneda-col"><strong>{{formatCurrency(totalDiferenciaPago)}}</strong></td>
        <td class="moneda-col"><strong>{{formatCurrency(totalIntereses)}}</strong></td>
        <td class="moneda-col"><strong>{{formatCurrency(totalAportesNoDepo)}}</strong></td>
        <td class="moneda-col"><strong>{{formatCurrency(totalSaldoDeudor)}}</strong></td>
        <td class="moneda-col"><strong>{{formatCurrency(totalActualizacion)}}</strong></td>
        <td class="moneda-col total-col con-deuda"><strong>{{formatCurrency(totalAdeudado)}}</strong></td>
        <td class="no-print"></td>
      </tr>
    </tfoot>
  </table>

  <!-- Observaciones -->
  <div class="observaciones-container">
    <div class="observaciones-label">OBSERVACIONES</div>
    <textarea [(ngModel)]="observaciones" class="observaciones-textarea" rows="3"></textarea>
  </div>

  <!-- Firma -->
  <div class="firma-container">
    <div class="firma-linea"></div>
    <div class="firma-texto">FIRMA Y ACLARACION DEL INSPECTOR</div>
  </div>
  </div><!-- Fin pagina-primera-acta -->

  <!-- Segunda página: Resumen de deuda -->
  <div class="page-break"></div>
  <div class="resumen-deuda-container">
    <!-- Encabezado -->
    <div class="resumen-header">
      <div class="resumen-logo">
        <img src="assets/img/osrga.jpeg" alt="OS.R.GA" class="logo-resumen">
      </div>
      <div class="resumen-titulo">
        <strong>OBRA SOCIAL DE RECIBIDORES DE GRANOS Y ANEXOS</strong><br>
        <strong>RNOS N° 118804</strong><br>
        <small>Av. Belgrano 510 - 5° Piso - Buenos Aires C.P. 1092 - Tel/Fax: 011 - 4331-0865</small><br>
        <small><a href="http://www.osrga.org.ar">www.osrga.org.ar</a></small>
      </div>
    </div>

    <!-- Datos del documento -->
    <table class="resumen-datos">
      <tr>
        <td><strong>Fecha:</strong></td>
        <td class="resumen-valor"><input type="text" [(ngModel)]="fechaLiquidacion" class="input-resumen" (change)="recalcularTodosLosPeriodos()"></td>
        <td><strong>VENCIMIENTO - PAGO OBLIGACIÓN:</strong></td>
        <td class="resumen-valor"><input type="text" [(ngModel)]="vencimientoPagoObligacion" class="input-resumen" placeholder="DD/MM/YYYY"></td>
      </tr>
      <tr>
        <td><strong>Razón Social o Apellido y Nombres:</strong></td>
        <td class="resumen-valor"><input type="text" [(ngModel)]="empresa" class="input-resumen" autocomplete="off"></td>
        <td><strong>CUIT:</strong></td>
        <td class="resumen-valor"><input type="text" [(ngModel)]="cuit" class="input-resumen"></td>
      </tr>
      <tr>
        <td><strong>Domicilio:</strong></td>
        <td class="resumen-valor" colspan="3"><input type="text" [(ngModel)]="domicilio" class="input-resumen input-wide"></td>
      </tr>
    </table>

    <!-- Tabla de montos -->
    <table class="resumen-montos">
      <tr>
        <td class="resumen-concepto">DIFERENCIA PAGO PARCIAL</td>
        <td class="resumen-monto">$ {{formatCurrency(totalDiferenciaPago)}}</td>
      </tr>
      <tr>
        <td class="resumen-concepto">INTERESES POR PAGO FUERA DE TERMINO</td>
        <td class="resumen-monto">$ {{formatCurrency(totalIntereses)}}</td>
      </tr>
      <tr>
        <td class="resumen-concepto">APORTES Y CONTR. NO DEPOSITADAS</td>
        <td class="resumen-monto">$ {{formatCurrency(totalAportesNoDepo)}}</td>
      </tr>
      <tr>
        <td class="resumen-concepto">SALDO DEUDOR</td>
        <td class="resumen-monto">$ {{formatCurrency(totalSaldoDeudor)}}</td>
      </tr>
      <tr>
        <td class="resumen-concepto">ACTUALIZACION DE INTERESES</td>
        <td class="resumen-monto">$ {{formatCurrency(totalActualizacion)}}</td>
      </tr>
      <tr class="resumen-total-row">
        <td class="resumen-concepto"><strong>TOTAL ADEUDADO DEL PERIODO</strong></td>
        <td class="resumen-monto"><strong>$ {{formatCurrency(totalAdeudado)}}</strong></td>
      </tr>
    </table>


    <!-- Plazo -->
    <p class="resumen-plazo">
      Se intima a Uds. al pago de la deuda detallada, dentro del plazo de
      <input type="number" [(ngModel)]="diasPlazo" style="width: 40px;"> (<input type="text" [(ngModel)]="diasPlazoLetras" style="width: 80px;">) días hábiles
      a partir de la fecha de notificación, bajo apercibimiento de iniciar acciones judiciales y/o administrativas tendientes a su cobro, con más los intereses y costas correspondientes.
    </p>

    <!-- Datos representante -->
    <div class="resumen-representante">
      <p>En la persona del Sr. <input type="text" [(ngModel)]="representanteNombre" class="input-representante"> con domicilio legal en <input type="text" [(ngModel)]="representanteDomicilio" class="input-representante"></p>
      <p>quien exhibió D.N.I. N° <input type="text" [(ngModel)]="representanteDNI" class="input-dni"> en su carácter de <input type="text" [(ngModel)]="representanteCargo" class="input-cargo"> de la empresa inspeccionada, firmante del Acta que se actualiza, se notifica de la conformación definitiva de las deudas, formando, la presente, parte integrante del instrumento mencionado.</p>
    </div>

    <!-- Firmas finales -->
    <div class="resumen-firmas">
      <div class="resumen-firma-col">
        <div class="firma-linea"></div>
        <strong>Inspector</strong><br>
        <small>Firma y Sello</small>
      </div>
      <div class="resumen-firma-col">
        <div class="firma-linea"></div>
        <strong>Fecha de Notificación</strong>
      </div>
      <div class="resumen-firma-col">
        <div class="firma-linea"></div>
        <strong>Responsable</strong><br>
        <small>Firma y Sello</small>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Configuración de Porcentajes -->
<div class="modal fade" [class.show]="modalConfiguracionAbierto" [style.display]="modalConfiguracionAbierto ? 'block' : 'none'" tabindex="-1" role="dialog" *ngIf="modalConfiguracionAbierto">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-info text-white">
        <h5 class="modal-title"><i class="fa fa-cog"></i> Configurar Porcentajes</h5>
        <button type="button" class="close text-white" (click)="cerrarModalConfiguracion()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="aporteSelect"><strong>Porcentaje de APORTE:</strong></label>
              <select class="form-control" id="aporteSelect" [(ngModel)]="aporteSeleccionado">
                <option [ngValue]="null">-- Seleccione un porcentaje --</option>
                <option *ngFor="let p of getPorcentajesPorTipo('aporte')" [ngValue]="p">
                  {{ p.anio }} - {{ formatearPorcentaje(p.porcentaje) }} - {{ p.titulo }}
                </option>
              </select>
              <small class="form-text text-muted" *ngIf="aporteSeleccionado">
                <strong>Seleccionado:</strong> {{ formatearPorcentaje(aporteSeleccionado.porcentaje) }} ({{ aporteSeleccionado.descripcion || aporteSeleccionado.titulo }})
              </small>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label for="contribucionSelect"><strong>Porcentaje de CONTRIBUCIÓN:</strong></label>
              <select class="form-control" id="contribucionSelect" [(ngModel)]="contribucionSeleccionada">
                <option [ngValue]="null">-- Seleccione un porcentaje --</option>
                <option *ngFor="let p of getPorcentajesPorTipo('contribucion')" [ngValue]="p">
                  {{ p.anio }} - {{ formatearPorcentaje(p.porcentaje) }} - {{ p.titulo }}
                </option>
              </select>
              <small class="form-text text-muted" *ngIf="contribucionSeleccionada">
                <strong>Seleccionado:</strong> {{ formatearPorcentaje(contribucionSeleccionada.porcentaje) }} ({{ contribucionSeleccionada.descripcion || contribucionSeleccionada.titulo }})
              </small>
            </div>
          </div>
        </div>

        <div class="alert alert-info mt-3">
          <i class="fa fa-info-circle"></i>
          <strong>Nota:</strong> Puede elegir porcentajes de diferentes años. Los valores seleccionados se aplicarán a los cálculos de liquidación.
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="cerrarModalConfiguracion()">
          <i class="fa fa-times"></i> Cancelar
        </button>
        <button type="button" class="btn btn-primary" (click)="aplicarConfiguracionPorcentajes()" [disabled]="!aporteSeleccionado || !contribucionSeleccionada">
          <i class="fa fa-check"></i> Aplicar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop del modal de porcentajes -->
<div class="modal-backdrop fade" [class.show]="modalConfiguracionAbierto" *ngIf="modalConfiguracionAbierto" (click)="cerrarModalConfiguracion()"></div>
